/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEnergyCheck: {
  name: 'energy-check';
  data: string;
} = {
  name: 'energy-check',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.992 2.124a1 1 0 0 0-1.824-.679l-8 12A1 1 0 0 0 4 15h5.867l-.86 6.876a1 1 0 0 0 1.825.679l8-12A1 1 0 0 0 18 9h-5.867l.86-6.876ZM11 13H5.869l4.613-6.92-.474 3.796A1 1 0 0 0 11 11h5.131l-4.613 6.92.474-3.796A1 1 0 0 0 11 13Zm9.707-11.707a1 1 0 0 0-1.414 0L17 3.586l-1.293-1.293a1 1 0 1 0-1.414 1.414L15.586 5a2 2 0 0 0 2.828 0l2.293-2.293a1 1 0 0 0 0-1.414Z" fill="currentColor"/></svg>`,
};
